import { render, staticRenderFns } from "./bio.vue?vue&type=template&id=81465918&scoped=true&"
import script from "./bio.vue?vue&type=script&lang=js&"
export * from "./bio.vue?vue&type=script&lang=js&"
import style0 from "./bio.vue?vue&type=style&index=0&id=81465918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81465918",
  null
  
)

export default component.exports